export function toPct(divisor: number, dividend: number) {
    if (dividend === 0)
        return 0
    else
        return Math.round(divisor / dividend * 100) ?? 0
}